// extracted by mini-css-extract-plugin
export default {"arrowActive":"Sidebar_arrowActive__YXPGt","arrowInactive":"Sidebar_arrowInactive__z0Y8v"};